var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0038a8",
    d: "M22.8 4.4H54V9H22.8zm0 9H54v4.4H22.8zM.7 22.1H54v4.5H.7zm0 9H54v4.4H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m11.3 13.3.7 1c-3 2.3-1.2 3.6-3.3 4.2 1.3-1.2-.2-1.4.9-4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "square",
    strokeMiterlimit: 20,
    strokeWidth: 0.2,
    d: "m11.3 13.3.7 1c-3 2.3-1.2 3.6-3.3 4.2 1.3-1.2-.2-1.4.9-4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 20,
    strokeWidth: 0.2,
    d: "M10.7 13.6c-1.6 2.7-.5 4.3-2 5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M11.8 11.1h1.4l-1.4 8-1.5-8zv8Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 20,
    strokeWidth: 0.2,
    d: "M11.8 11.1h1.4l-1.4 8m0-8h-1.5l1.5 8m0-8v8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m9.9 12.3-.3 1.3c-3.7-.6-3.3 1.6-5.3.6 1.9 0 .9-1.2 3.6-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "square",
    strokeMiterlimit: 20,
    strokeWidth: 0.2,
    d: "m9.9 12.3-.3 1.3c-3.7-.6-3.3 1.6-5.3.6 1.9 0 .9-1.2 3.6-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 20,
    strokeWidth: 0.2,
    d: "M9.3 12.1c-3.1.8-3.4 2.6-5 2.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m11.8 11.1 1 1-6.7 4.7 4.6-6.7zl-5.6 5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 20,
    strokeWidth: 0.2,
    d: "m11.8 11.1 1 1-6.7 4.7m5.7-5.7-1-1L6 16.8m5.7-5.7L6 16.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m9.6 10.6-1.1.8C6.3 8.4 5 10.2 4.3 8c1.3 1.3 1.4-.2 4.2 1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "square",
    strokeMiterlimit: 20,
    strokeWidth: 0.2,
    d: "m9.6 10.6-1.1.8C6.3 8.4 5 10.2 4.3 8c1.3 1.3 1.4-.2 4.2 1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 20,
    strokeWidth: 0.2,
    d: "M9.3 10c-2.8-1.6-4.3-.5-5-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M11.8 11.1v1.5l-8-1.5 8-1.5zh-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 20,
    strokeWidth: 0.2,
    d: "M11.8 11.1v1.5l-8-1.5m8 0V9.6l-8 1.5m8 0h-8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M10.6 9.2 9.3 9c.6-3.7-1.6-3.3-.6-5.3 0 1.8 1.1.8 2.3 3.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "square",
    strokeMiterlimit: 20,
    strokeWidth: 0.2,
    d: "M10.6 9.2 9.3 9c.6-3.7-1.6-3.3-.6-5.3 0 1.8 1.1.8 2.3 3.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 20,
    strokeWidth: 0.2,
    d: "M10.7 8.6c-.7-3-2.6-3.4-2-5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m11.8 11.1-1 1L6 5.4l6.7 4.7zL6 5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 20,
    strokeWidth: 0.2,
    d: "m11.8 11.1-1 1L6 5.4m5.7 5.7 1-1L6 5.4m5.7 5.7L6 5.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m12.3 9-.8-1.2c3-2.2 1.2-3.4 3.4-4.1-1.4 1.2.2 1.4-1 4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "square",
    strokeMiterlimit: 20,
    strokeWidth: 0.2,
    d: "m12.3 9-.8-1.2c3-2.2 1.2-3.4 3.4-4.1-1.4 1.2.2 1.4-1 4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 20,
    strokeWidth: 0.2,
    d: "M12.8 8.6c1.7-2.7.6-4.2 2-5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M11.8 11.1h-1.5l1.5-8 1.4 8zv-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 20,
    strokeWidth: 0.2,
    d: "M11.8 11.1h-1.5l1.5-8m0 8h1.4l-1.4-8m0 8v-8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m13.7 10 .2-1.4c3.7.6 3.3-1.6 5.3-.6-1.8 0-.8 1.2-3.5 2.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "square",
    strokeMiterlimit: 20,
    strokeWidth: 0.2,
    d: "m13.7 10 .2-1.4c3.7.6 3.3-1.6 5.3-.6-1.8 0-.8 1.2-3.5 2.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 20,
    strokeWidth: 0.2,
    d: "M14.3 10c3-.7 3.4-2.5 5-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m11.8 11.1-1-1 6.7-4.7-4.7 6.7zl5.7-5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 20,
    strokeWidth: 0.2,
    d: "m11.8 11.1-1-1 6.7-4.7m-5.7 5.7 1 1 4.7-6.7m-5.7 5.7 5.7-5.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m14 11.6 1-.7c2.3 3 3.5 1.2 4.2 3.3-1.3-1.3-1.4.2-4.1-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "square",
    strokeMiterlimit: 20,
    strokeWidth: 0.2,
    d: "m14 11.6 1-.7c2.3 3 3.5 1.2 4.2 3.3-1.3-1.3-1.4.2-4.1-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 20,
    strokeWidth: 0.2,
    d: "M14.3 12.1c2.7 1.7 4.2.6 5 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M11.8 11.1V9.6l8 1.5-8 1.5zh8Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 20,
    strokeWidth: 0.2,
    d: "M11.8 11.1V9.6l8 1.5m-8 0v1.5l8-1.5m-8 0h8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m13 13 1.3.3c-.6 3.7 1.6 3.3.6 5.2 0-1.8-1.2-.8-2.3-3.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "square",
    strokeMiterlimit: 20,
    strokeWidth: 0.2,
    d: "m13 13 1.3.3c-.6 3.7 1.6 3.3.6 5.2 0-1.8-1.2-.8-2.3-3.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 20,
    strokeWidth: 0.2,
    d: "M12.8 13.6c.8 3.1 2.6 3.4 2 5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m11.8 11.1 1-1 4.7 6.7-6.8-4.7zl5.8 5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 20,
    strokeWidth: 0.2,
    d: "m11.8 11.1 1-1 4.7 6.7m-5.7-5.7-1 1 6.7 4.7m-5.7-5.7 5.7 5.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    stroke: "#000",
    strokeMiterlimit: 20,
    strokeWidth: 0.2,
    d: "M11.8 13.8a2.7 2.7 0 1 0 0-5.4 2.7 2.7 0 0 0 0 5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.8 10q-.1.1-1-.1c-.5 0-.6.4-.7.3l.7-.6zm-.8.3q.2.3-.1.4-.4-.1-.3-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.2 10.5q0-.4.7-.4.6.1.7.4l-.7-.2q-.4 0-.7.2m.1 0 .5.2q.4 0 .6-.2c.2-.1-.3.3-.5.3q-.6 0-.6-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.1 10.7q.5-.3 0-.5s.3.3 0 .5m-1.3 1.5h.4q.4.2.9 0c-.6.3-.3.2-1.3.2h-.1m1.5.1-.3-.4q.3.2.3.4m-1.4.2c.6 0 .5 0 1.3-.4-.6 0-.7.3-1.3.3h-.1m0-.8h1.1l-.3-.1c-.2 0-.1-.4-.3-.4v.2q-.1.2-.2 0 0 .2-.2.2m-2-1.7q.2.1.9-.1c.6 0 .7.4.8.3l-.7-.6c-.2 0-.8.2-1 .4m.7.3q-.2.3.2.4.3-.1.3-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.3 10.5q0-.4-.6-.4-.6.1-.8.4l.8-.2zm0 0-.6.2q-.3 0-.5-.2c-.2-.1.2.3.5.3q.5 0 .5-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.4 10.7q-.3-.3 0-.5zm1.4 1.5h-.4q-.4.2-1 0c.6.3.4.2 1.4.2h.1m-1.5.1.2-.4zm1.4.2c-.6 0-.5 0-1.3-.4l1.3.3h.1m-.1-.8h-1l.2-.1c.2 0 .2-.4.4-.4l-.1.2h.3q0 .2.2.2m0 1.3c-.1 0-.5 0 0 0s.1 0 0 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUy);
export default __webpack_public_path__ + "static/media/uy.11ce865a585630ce44af1dd4281724da.svg";
export { ForwardRef as ReactComponent };